// extracted by mini-css-extract-plugin
export default {"goalAmount":"CampaignProgressCompact_goalAmount__Vu5lx","progressBar":"CampaignProgressCompact_progressBar__aej+M"};